import { render, staticRenderFns } from "./pufaConstitutionAgreement.vue?vue&type=template&id=63c5561c&scoped=true"
import script from "./pufaConstitutionAgreement.vue?vue&type=script&lang=js"
export * from "./pufaConstitutionAgreement.vue?vue&type=script&lang=js"
import style0 from "./pufaConstitutionAgreement.vue?vue&type=style&index=0&id=63c5561c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c5561c",
  null
  
)

export default component.exports